// @flow

import * as React from 'react';
import styled from 'styled-components';

type Props = {
  start: number,
  end: number,
  disabled?: boolean,
};

const FillContainer = styled.span`
  height: 4px;
  border-radius: 100px;
  background-color: ${(props) => props.theme.slider.fill.backgroundColor};
  box-shadow: ${(props) => props.theme.slider.fill.boxShadow};
  position: absolute;
  display: inline-block;
  max-width: 100%;
`;

export default class Fill extends React.Component<Props> {
  static defaultProps = {
    start: 0,
    end: 0,
  };

  /**** Render ****/

  render() {
    return (
      <FillContainer
        /* Setting the most dynamic rules inline to prevent css flooding  */
        style={{
          width: this.props.end - this.props.start + '%',
          left: this.props.start + '%',
        }}
      />
    );
  }
}
